module.exports = __webpack_public_path__ + "img/croisees_des_langues.f65fd662.png";